import { Link } from 'react-router-dom';

const links = [
  ['/legal', 'Aviso Legal'],
  ['/privacy', 'Privacidad'],
  ['/cookies', 'Cookies'],
  ['/terms', 'Condiciones de Uso'],
  ['/contact', 'Contacto'],
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 py-8 text-sm text-slate-500 space-y-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <p>© {new Date().getFullYear()} Asociación Española del Aluminio y Tratamientos de Superficie</p>
          <nav aria-label="Información legal" className="flex flex-wrap gap-x-5 gap-y-2">
            {links.map(([to, label]) => <Link key={to} to={to} className="text-aea-blue hover:underline">{label}</Link>)}
          </nav>
        </div>
        <div className="flex flex-col gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <a href={`${process.env.REACT_APP_BACKEND_URL}/api/docs/manual`} target="_blank" rel="noreferrer" className="text-aea-blue hover:underline font-medium">Manual de uso (PDF)</a>
          <p className="text-xs">Espacio de Datos Sectorial · Data Spaces UE</p>
        </div>
      </div>
    </footer>
  );
}
